import { useToast } from "vue-toastification";
import { i18n } from "./../../i18n";
import { ref } from "vue";
import axios from "./../../axios";

export default function useContactForm() {
  const data = ref({}),
    toast = useToast(),
    { t } = i18n.global;

  function changeField(event) {
    data.value[event.name] = event.value;
  }

  function onSubmit() {
    const form = document.getElementById("contact-form"),
      url = form.getAttribute("action");

    axios.post(url, data.value).then((data) => {
      toast.success(t("success_send_contact"));

      form.reset();
    });
  }

  function invalidSubmit() {
    toast.error(t("fill_required_fields"));
  }

  return {
    changeField,
    onSubmit,
    invalidSubmit,
    data,
  };
}
